export const hospitality = {
    meta_title: "Hospitality Fiber Networks | GPON Solutions for Hotels ",
    meta_description: "Niurix GPON hospitality solutions deliver reliable fiber connectivity and triple-play services to every hotel room.",

    section1: {
        banner_img: "Hospitality Banner",
        banner_img_mobile: "Hosp Banner",
        title: "Catering to Exceptional Guest Experiences: Pioneering Next-Gen Networking Solutions to Redefine Hospitality.",
    },
    section2: {
        img: "HOSPITALITY1",
        title: `Enabling <span>Uninterrupted Connectivity</span> - Around the Clock, <span>Anywhere</span>.`,
        subtitle: "Lorem_Subtitle",
        desc: "A fiber optic solution designed to meet the needs of hospitality businesses of today and tomorrow. With Niurix, let your customers have the ultimate guest experience by empowering your property with a next-gen solution.",
    },

    section3: [
        {
            device_img: "ISP Router",
            device_title: "Router",
        },

        {
            device_img: "olt",
            device_title: "OLT",
        },

        {
            device_img: "Splitter",
            device_title: "Splitter",
        },

        {
            device_img: "Internet traffic",
            device_title: "Internet traffic",
        },

        {
            device_img: "1G Fiber",
            device_title: "1G Fiber",
        },

        {
            device_img: "Ethernet cable",
            device_title: "Ethernet cable",
        },

        {
            device_img: "ONT",
            device_title: "ONT",
        },

        {
            device_img: "IPTV",
            device_title: "IPTV",
        },

        {
            device_img: "Router",
            device_title: "Access Point",
        },

        {
            device_img: "telephone",
            device_title: "telephone",
        },

        {
            device_img: "wireless",
            device_title: "Wireless",
        },
    ],
    section4: {
        title: "Advantages of Niurix Hospitality Solutions",
        desc: "Seamless and high-speed internet is one of the most crucial factors in enhancing guest satisfaction for hotel services. Niurix's FTTR (Fiber to the Room) hospitality solution paves the way for you to elevate customer expectations, foster loyalty, and boost revenue, all in one go.",
        cards: [
            {
                cards_img: "Budgetary-Efficiency",
                cards_title: "Budgetary Efficiency",
                // cards_desc: "Reduce cost and in turn your working capital with the energy efficient networking solution.",
            },

            {
                cards_img: "Triple-Play-Services",
                cards_title: "Triple Play Services",
                // cards_desc: "Easy integration of video, voice, and networking devices in one room without the jungle of wires.",
            },

            {
                cards_img: "Structured-Spatial-Layout",
                cards_title: "Structured Spatial Layout",
                // cards_desc: "Create a clean and harmonized guest space by getting rid of all the unwanted home run cables.",
            },

            {
                cards_img: "Single-Configuration-Deployment",
                cards_title: "Single Configuration Deployment",
                // cards_desc: "Seamless, quick and one-time deployment by the experts without hindering the business operations.",
            },
        ],
    },
    section5: {
        img: "contact banner",
        title: "Loremm",
    },
};
